import { DatePickerProvider } from "./DatePickerContext";

import DatePickerContainer from "./DatePickerContainer";
import DatePickerDropdown from "./DatePickerDropdown";
import DatePickerInput from "./DatePickerInput";
import DatePickerRangeInput from "./DatePickerRangeInput";

import { DatePickerProps } from "./datePicker.type";

const DatePicker = ({
  id,
  label,
  placeholder,
  value,
  dateFormat = "YYYY-MM-DD",
  disabledDays,
  displayMode = "dropdown",
  minDate,
  maxDate,
  rangePicker,
  rangeStart,
  rangeEnd,
  onChange = () => {},
  onRangeChange = () => {},
  onToggle = () => {},
}: DatePickerProps) => {
  return (
    <DatePickerProvider>
      <DatePickerContainer id={id}>
        {!rangePicker && (
          <DatePickerInput
            label={label}
            placeholder={placeholder}
            value={value}
            dateFormat={dateFormat}
            displayMode={displayMode}
            onChange={onChange}
          />
        )}
        {rangePicker && (
          <DatePickerRangeInput
            label={label}
            dateFormat={dateFormat}
            displayMode={displayMode}
            rangeStart={rangeStart}
            rangeEnd={rangeEnd}
          />
        )}
        <DatePickerDropdown
          displayMode={displayMode}
          disabledDays={disabledDays}
          minDate={minDate}
          maxDate={maxDate}
          dateFormat={dateFormat}
          onChange={onChange}
          onRangeChange={onRangeChange}
          onToggle={onToggle}
          rangePicker={rangePicker}
        />
      </DatePickerContainer>
    </DatePickerProvider>
  );
};

export default DatePicker;
